import { FormikPasswordInput } from "./formik-password-input";
import { PasswordRequirementsChecklist } from "./password-requirements-checklist";
import { useFormikContext } from "formik";
import { Label } from "./ui/label";
import { ComponentPropsWithoutRef } from "react";

interface PasswordFieldWithRequirementsProps extends ComponentPropsWithoutRef<
    typeof FormikPasswordInput
> {
    label: string;
    showRequirements?: boolean;
}

export const PasswordFieldWithRequirements = ({
    label,
    name,
    id,
    showRequirements = false,
    ...props
}: PasswordFieldWithRequirementsProps) => {
    const { values, errors } = useFormikContext<{
        [key: string]: unknown;
    }>();

    const password = values[name];
    const error = errors[name];

    return (
        <div className="grid gap-2">
            <Label htmlFor={id}>{label}</Label>
            <FormikPasswordInput id={id} name={name} {...props} />
            {typeof error === "string" && error ? (
                <span className="text-xs text-red-600">{error}</span>
            ) : null}
            {showRequirements ? (
                <PasswordRequirementsChecklist
                    password={typeof password === "string" ? password : ""}
                />
            ) : null}
        </div>
    );
};
